import { Typography } from '@material-ui/core'
import React from 'react'

const Description = ({ description }) => {
    if (!description) return null

    return <Typography className="loanCalculatorDescription">{description}</Typography>
}

export default Description
